import { css } from 'styled-components';

const THEME_CONF = 'flexboxgrid';

const configCache = [];
const makeCacheId = props =>
  JSON.stringify((props.theme && props.theme[THEME_CONF]) || {});
const resolveConfig = props => {
  const themeConf = (props.theme && props.theme[THEME_CONF]) || {};

  const conf = {
    ...themeConf,
    container: {
      ...themeConf.container,
    },
    breakpoints: {
      ...themeConf.breakpoints,
    },
  };

  conf.media = Object.keys(conf.breakpoints).reduce((media, breakpoint) => {
    const breakpointWidth = conf.breakpoints[breakpoint];
    media[breakpoint] = makeMedia(
      [conf.mediaQuery, breakpoint !== 0 && `(min-width: ${breakpointWidth}em)`]
        .filter(Boolean)
        .join(' and ')
    );
    return media;
  }, {});

  return conf;
};

export const DIMENSION_NAMES = [
  'base',
  'xs',
  'xs_sm',
  'sm',
  'sm_md',
  'md',
  'lg',
  'xl',
];

export default function config(props) {
  const cacheId = makeCacheId(props);
  if (configCache[0] === cacheId) {
    return configCache[1];
  }

  const conf = resolveConfig(props);

  configCache[0] = cacheId;
  configCache[1] = conf;

  return conf;
}

function makeMedia(media) {
  return (...args) => css`
    @media ${media} {
      ${css(...args)}
    }
  `;
}
